<template>
    <section>
        <div class="news_box">
            <div class="title">庆云县举行成品油交易大数据项目签约仪式</div>
            <p class="time">发布时间：2018-11-13</p>
            <p class="author">来源:庆云县人民政府办公室</p>
            <div>
                <video controls src="../../assets/newActive/庆云新闻-思创签约.mp4"></video>
            </div>
            <p class="video">（视频来源：庆云新闻）</p>
            <div class="part1">北京思创银联科技股份有限公司与庆云县政府举行成品油交易大数据项目签约仪式。</div>
            <div class="img_box1">
                <img src="../../assets/newActive/庆云签约大图.jpg" alt="">
            </div>
            <div class="part2"><span style="padding-left:28px;"></span>11月12日，北京思创银联科技股份有限公司与庆云县政府举行成品油交易大数据项目签约仪式，庆云县县委副书记、县长孙洪昌，副县长张传军，北京思创银联科技股份有限公司董事长于晓军出席。</div>
            <div class="part3"><span style="padding-left:28px;"></span>此次签约项目旨在借助庆云县成品油行业优势，建设基于数据驱动的加油站品牌联盟，从而整合油品供应联盟链建设，并辅助以人工智能数据模型及区块链技术，建设国内最大的可信成品油交易区块链平台。</div>
        </div>
    </section>
</template>
<script>
    export default {
        
    }
</script>
<style scoped>
    .news_box{
        width: 1000px;
        margin: 0 auto;
    }
    .title{
        margin-top: 24px;
        padding-bottom: 24px;
        font-size: 28px;
    }
    .time, .author, .video{
        margin-top: 12px;
    }
    .author{
        margin-bottom: 24px;
    }
    .part1{
        font-size: 16px;
        font-weight: bold;
        margin-top: 24px;
        padding-bottom: 24px;
    }
    .part2, .part3{
        text-align: left;
        font-size: 14px;
        margin: 24px 0;
    }
    .img_box1 img{
        width: 96%;
    }
</style>
